var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEanScannerFrameVdo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 107,
    viewBox: "0 0 249 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 37.5V10C4 6.68629 6.68629 4 10 4H37.5",
    stroke: "#32AC5C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M245 37.5V10C245 6.68629 242.314 4 239 4H211.5",
    stroke: "#32AC5C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 103.5H10C6.68629 103.5 4 100.814 4 97.5L4 70",
    stroke: "#32AC5C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M211 103.5H238.5C241.814 103.5 244.5 100.814 244.5 97.5V70",
    stroke: "#32AC5C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEanScannerFrameVdo);
export default __webpack_public_path__ + "static/media/ean_scanner_frame_vdo.cd7a1d59c3a5ae8f5ba14feb997a4e5e.svg";
export { ForwardRef as ReactComponent };